import { forwardRef, type ReactNode } from "react";
import { cn } from "@/lib/utils";

export interface PullquoteProps {
  quote: ReactNode;
  attribution?: ReactNode;
  role?: ReactNode;
  align?: "left" | "center";
  className?: string;
}

export const Pullquote = forwardRef<HTMLElement, PullquoteProps>(function Pullquote(
  { quote, attribution, role, align = "left", className },
  ref,
) {
  return (
    <figure ref={ref} className={cn("max-w-3xl", align === "center" && "mx-auto text-center", className)}>
      <blockquote className="text-display text-2xl leading-snug md:text-3xl md:leading-snug">
        <span aria-hidden className="mr-1 text-accent-press">«</span>
        {quote}
        <span aria-hidden className="ml-1 text-accent-press">»</span>
      </blockquote>
      {(attribution || role) && (
        <figcaption className="mt-6 flex flex-col gap-0.5">
          {attribution && <span className="text-sm font-medium text-foreground">{attribution}</span>}
          {role && <span className="dateline">{role}</span>}
        </figcaption>
      )}
    </figure>
  );
});
